import { useEffect, useRef, type RefObject } from 'react';

// Sluitgedrag van een uitklapper (menu of paneel onder een knop): Esc of een pointerdown buiten
// `ref` sluit. Valt de knop zelf binnen `ref`, dan klapt een klik daarop het paneel dicht in plaats
// van het meteen weer te openen. De luisteraars zitten op document in de bubbelfase en stoppen
// niets: lagen die in de vangfase luisteren (vellen, vensters, het rechtsklikmenu) gaan voor en
// vangen Esc zelf af als dat moet. De callback loopt via een ref, zodat alleen `enabled` de
// luisteraars aan- of afhaakt; hij krijgt de gebeurtenis mee voor wie onderscheid wil maken.

export function useDismiss(ref: RefObject<HTMLElement | null>, onClose: (e: Event) => void, opts: { enabled?: boolean | undefined } = {}): void {
  const enabled = opts.enabled ?? true;
  const close = useRef(onClose);
  useEffect(() => {
    close.current = onClose;
  });
  useEffect(() => {
    if (!enabled) return;
    const onPointer = (e: Event) => {
      // composedPath: ook goed als het aangeklikte element intussen uit de pagina verdween.
      const el = ref.current;
      if (el && e.composedPath().includes(el)) return;
      close.current(e);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close.current(e);
    };
    document.addEventListener('pointerdown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [enabled, ref]);
}
